import { render, staticRenderFns } from "./Lv1Fiera.vue?vue&type=template&id=33b67de0"
import script from "./Lv1Fiera.vue?vue&type=script&lang=js"
export * from "./Lv1Fiera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports